import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import ContactSection from '@/pages/home/components/ContactSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FAQSection from '@/pages/home/components/FAQSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <MediaSection />
        <FAQSection />
        <RankingSection />
        <AppSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
        <TopicsSection />
        <AboutSection />
        <CarouselSection />
        <CardsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}